var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2"},[_c('el-tree',{attrs:{"allow-drag":_vm.allowDrag,"allow-drop":_vm.allowDrop,"data":_vm.folderData,"default-expand-all":"","draggable":"","highlight-current":"","node-key":"id","props":_vm.defaultProps,"render-content":_vm.renderContent},on:{"node-drop":_vm.handleDrop,"node-click":_vm.setDefaultFileFolder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }